module.exports = __webpack_public_path__ + "marina.dc56126da840923c87d9.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/employees/marina.jpg
// module id = ../../../../../src/assets/employees/marina.jpg
// module chunks = 0